export default "__VITE_ASSET__WS3UVLTW__"